import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { CustomCta } from './custom-banners.model';
import { transformBannerCustomCtaForApi } from './custom-banners.transformers';
import type { CustomBannersCollection } from './custom-banners.types';

export function customBannersBackend(): Backend<CustomBannersCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUserId, ids, query, order) => ({
      endpoint: 'common/0.1/custom_banners/',
      params: {
        ids,
        entity_ids: getQueryParamValue(query, 'entityId'),
        entity_type: getQueryParamValue(query, 'entityType')[0],
        locations: getQueryParamValue(query, 'location'),
        active_only: query?.searchQueryParams.activeOnly,
        banner_title_search: query?.searchQueryParams.title,
        offset: query?.searchQueryParams.offset,
      },
    }),
    push: (authUserId, document, extra) => {
      return {
        endpoint: 'superuser/0.1/custom_banners/',
        payload: {
          entity_id: document.entityId,
          entity_type: document.entityType,
          closeable: document.closeable,
          title: document.title,
          body: document.body,
          location: document.location,
          end_date: document.endDate ? document.endDate / 1000 : undefined,
          start_date: document.startDate / 1000,
          text_color: document.textColor,
          ctas: document.ctas.map(transformBannerCustomCtaForApi),
          background_image_uuid: document.backgroundImageUuid,
        },
        extractId: response => response.custom_banner.id,
      };
    },
    set: undefined,
    update: (authUserId, updatedDocument, originalDocument) => {
      return {
        endpoint: `superuser/0.1/custom_banners/${originalDocument.id}/`,
        method: 'PUT',
        payload: {
          id: originalDocument.id,
          background_image_uuid: updatedDocument.backgroundImageUuid,
          body: updatedDocument.body,
          title: updatedDocument.title,
          ctas:
            updatedDocument.ctas &&
            updatedDocument.ctas.map(cta =>
              transformBannerCustomCtaForApi(cta as CustomCta),
            ),
          text_color: updatedDocument.textColor,
          start_date: updatedDocument.startDate
            ? updatedDocument.startDate / 1000
            : undefined,
          end_date: updatedDocument.endDate
            ? updatedDocument.endDate / 1000
            : undefined,
          closeable: updatedDocument.closeable,
        },
      };
    },
    remove: undefined,
  };
}
